import React from "react"

export function Shield(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_324_5120)">
        <path
          d="M7.00001 0C7.12579 0 7.25157 0.0273438 7.36642 0.0792969L12.5152 2.26406C13.1168 2.51836 13.5652 3.11172 13.5625 3.82812C13.5488 6.54063 12.4332 11.5035 7.72189 13.7594C7.26525 13.9781 6.73478 13.9781 6.27814 13.7594C1.56681 11.5035 0.451184 6.54063 0.437512 3.82812C0.434778 3.11172 0.883216 2.51836 1.48478 2.26406L6.63634 0.0792969C6.74845 0.0273438 6.87423 0 7.00001 0ZM7.00001 1.82656V12.1625C10.7734 10.3359 11.7879 6.2918 11.8125 3.86641L7.00001 1.82656Z"
          fill="#DC2626"
        />
      </g>
      <defs>
        <clipPath id="clip0_324_5120">
          <path d="M0 0H14V14H0V0Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
